import { useStore } from "react-redux";
import useCommonApi from "../api/useCommonApi";
import { buildCreateGuiaRequest } from "../components/servicioAdicional/buildCreateGuiaRequest";
import { IGuiaCreateResult } from "../entities/guias/IGuiaCreateResult";
import { ApplicationState } from "../redux/reducers";
import { traducirMessage } from "../blocks/traductor";

export type CreateGuiaHookResult =
    | { ok: true; data: IGuiaCreateResult }
    | { ok: false; errorMessage: string };

const MSG_PANTALLA_371 = "msg_pantalla_371";

const mapCreateResponse = (result: any): IGuiaCreateResult => ({
    guiaId: Number(result?.guiaId) || 0,
    numGuia: result?.numGuia ?? "",
    facturaId: Number(result?.facturaId) || 0,
    subTotal: Number(result?.subTotal) || 0,
    iva: Number(result?.iva) || 0,
    retencion: Number(result?.retencion) || 0,
    total: Number(result?.total) || 0,
    timbradoExitoso: result?.timbradoExitoso !== false,
    timbradoMensaje: result?.timbradoMensaje ?? ""
});

const useCreateGuia = () => {
    const api = useCommonApi();
    const store = useStore<ApplicationState>();

    const crearGuia = async (operationId: string): Promise<CreateGuiaHookResult> => {
        if (!operationId?.trim()) {
            return { ok: false, errorMessage: "OperationId requerido para crear la guía." };
        }

        const state = store.getState();
        const request = buildCreateGuiaRequest({
            operationId,
            guiaWizard: state.guiaWizard,
            guiaOrigen: state.guiaOrigen,
            guiaDestino: state.guiaDestino,
            guiaMercancias: state.guiaMercancias,
            guiaMercanciasComplementarias: state.guiaMercanciasComplementarias,
            guiaServicios: state.guiaServicios,
            idioma: state.idioma?.idioma || localStorage.getItem("idioma") || "es-MX"
        });

        try {
            const result = await api.postAsync<any>("guia", request);
            if (!result?.numGuia && !result?.guiaId) {
                return { ok: false, errorMessage: "La API no devolvió identificador de guía." };
            }
            return { ok: true, data: mapCreateResponse(result) };
        } catch (e) {
            const err = e as {
                response?: { data?: { error?: { message?: string } } };
                data?: { error?: { message?: string } };
                message?: string;
            };
            const msg =
                err?.response?.data?.error?.message
                || err?.data?.error?.message
                || err?.message
                || "Error al generar la guía";

            const errorMessage = msg === MSG_PANTALLA_371
                ? traducirMessage(371)
                : msg;

            return { ok: false, errorMessage };
        }
    };

    return { crearGuia };
};

export default useCreateGuia;
